import { VStack } from '@web/components/atoms/Layout'
import { ExtraFields, useDonationFormContext } from '@web/components/page-components/DonationForm'
import { PageButton } from '@web/components/page-components/PageButton'
import NameForm from '@web/components/page-components/DonationForm/components/molecules/NameForm'
import DonationFormEmailInput from '@web/components/page-components/DonationForm/components/atoms/DonationFormEmailInput'
import ProfileSelector from './ProfileSelector'

type DonationFormFieldsFormProps = {
  actionSlot?: React.ReactNode
}

const DonationFieldsForm = ({ actionSlot }: DonationFormFieldsFormProps) => {
  const extraFields = useDonationFormContext((state) => state.settings.extraFields)
  const nextStep = useDonationFormContext((state) => state.actions.nextStep)
  const validateForm = useDonationFormContext((state) => state.actions.validateForm)
  return (
    <VStack
      as="form"
      onSubmit={async (e) => {
        e.preventDefault()
        const elements = Object.keys(e.target)

        if (!validateForm(true)) {
          return
        }

        for (const element of elements) {
          if (
            (e.target[element] instanceof HTMLInputElement ||
              e.target[element] instanceof HTMLSelectElement ||
              e.target[element] instanceof HTMLTextAreaElement) &&
            (e.target[element].getAttribute('aria-invalid') === 'true' ||
              (e.target[element].getAttribute('aria-required') === 'true' && !e.target[element].value))
          ) {
            e.target[element].scrollIntoView()
            return
          } else if (
            e.target[element] instanceof HTMLInputElement &&
            e.target[element].type === 'checkbox' &&
            e.target[element].getAttribute('data-required') &&
            !e.target[element].checked
          ) {
            e.target[element].scrollIntoView()
            return
          }
        }

        nextStep()
      }}
      w="100%"
      gap="16px"
    >
      <VStack w="100%">
        <NameForm />
        <DonationFormEmailInput />
        <ExtraFields fields={extraFields} Components={{ ProfileSelector }} />
      </VStack>
      {actionSlot ?? <PageButton id="next-step-from-1" name="Primary" type="submit" buttonText="Next" width="100%" />}
    </VStack>
  )
}

export default DonationFieldsForm
